function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{opacity:0.4295;filter:url(#filter864);enable-background:new    ;}\n\t.st1{opacity:0.1255;fill:#0D6D9E;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{fill:#D6DCE4;}\n\t.st4{font-family:'Helvetica';}\n\t.st5{font-size:80px;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#E1E8F0;}\n");

var _ref3 = /*#__PURE__*/React.createElement("filter", {
  colorInterpolationFilters: "sRGB",
  height: 1.0345,
  id: "filter864",
  width: 1.0184,
  x: -0.0092016,
  y: -0.017244
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.1741753
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("rect", {
  className: "st1",
  width: 567.1,
  height: 302.6
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(142.35 58.632)"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "287,54 287,244 0,244 0,0 233,0 254,30  "
}), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 63.5001 153)",
  className: "st3 st4 st5"
}, "PDF"), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "287,54 233,0 233,54  "
}));

function SvgPdfAssetTypeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 567.1 302.6",
    style: {
      enableBackground: "new 0 0 567.1 302.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfAssetTypeIcon);
export default __webpack_public_path__ + "static/media/pdf-asset-type-icon.b8091092.svg";
export { ForwardRef as ReactComponent };